import React, { createContext, useState, useEffect } from "react";
import { storeProducts, detailProduct } from "../../data";

export const ProductContext = createContext();

const ProductContextProvider = (props) => {
  const [state, setState] = useState({
    products: [],
    detailProduct: detailProduct,
    modalProduct: detailProduct,
    modalIsOpen: undefined,
    cart: [],
  });

  const setProducts = () => {
    let tempProducts = [];
    storeProducts.forEach((item) => {
      const singleItem = { ...item };
      tempProducts = [...tempProducts, singleItem];
    });
    setState({
      ...state,
      products: tempProducts,
    });
  };

  useEffect(() => {
    setProducts();
  }, []);

  const getItemById = (id) => {
    const product = state.products.find((item) => item.id === id);
    return product;
  };

  const handleDetail = (id) => {
    const product = getItemById(id);
    setState({
      ...state,
      detailProduct: product,
    });
  };

  const addToCart = (id) => {
    // state mutation not allowed so we spread the state
    let tempProducts = [...state.products];
    // here we find the index of a particular product by its id using the
    // getItemById(id) function
    const index = tempProducts.indexOf(getItemById(id));
    // we get that product by id and set it as product[i] interpretes as product[1],product[2] etc
    const product = tempProducts[index];
    // here we then added it to cart since we already have that specific product
    // add to cart becomes true
    product.inCart = true;
    // here we increment the count
    product.count = 1;
    // here we set the price to the current price
    const price = product.price;
    // here we set the total as the price for now
    product.total = price;

    setState({
      ...state,
      products: tempProducts,
      cart: [...state.cart, product],
    });

    console.log(state);
  };

  const openModal = (id) => {
    const product = getItemById(id);
    setState({
      ...state,
      modalProduct: product,
      modalIsOpen: true,
    });
  };

  const closeModal = () => {
    setState({
      ...state,
      modalIsOpen: false,
    });
  };

  return (
    <ProductContext.Provider
      value={{
        state,
        handleDetail,
        addToCart,
        openModal,
        closeModal,
      }}
    >
      {props.children}
    </ProductContext.Provider>
  );
};

export default ProductContextProvider;
